<script>
import ModalStats from './components/ModalStats.vue'
import ModalSuccess from './components/ModalSuccess.vue'
import ModalHelp from './components/ModalHelp.vue'
import {Splide, SplideSlide} from '@splidejs/vue-splide';
import Inputmask from 'inputmask';
import '@splidejs/vue-splide/css/core';
import axios from "axios";

const mask = function(el, binding) {
                Inputmask(binding.value).mask(el);
            }
const DEFAULT_API = "/house/calc";
const API_URL = typeof process.env.VUE_APP_API_URL !== "undefined" && process.env.VUE_APP_API_URL  ?
    process.env.VUE_APP_API_URL : DEFAULT_API;


export default {
  name: 'CalcApp',
  components: {
    ModalStats,
    ModalSuccess,
    ModalHelp,
    Splide,
    SplideSlide,
  },
  directives: {
    mask
  },
  delimiters: ["[[", "]]"],
  template:`
  <div id="calc_container" :class="dynamicClass">
  <transition-group name="fade">
  <template v-if="isLoaded">
  <transition-group name="fade" tag="section" class="section">
    <div v-if="current_step === 1">
      <section class="section">
        <div class="section__header">
          <h1 v-if="dynamicTitle" class="section__title">Подобрать оборудование</h1>
          <h1 v-else class="section__title">Подбор коттеджного оборудования для очистки воды</h1>
          <div class="section__caption">Ответьте на вопросы и мы подберем для вас оборудование. Это займет пару минут
          </div>
        </div>
        <div class="section__container cont">
          <div class="section__row">
            <div class="main-form section__form">
              <div class="main-form__header">
                <div class="main-form__title">Общая информация</div>
              </div>

              <div class="main-form__field">
                <div class="main-form__caption">Водозабор</div>
                <label class="custom-radio main-form__item">
                  <input class="custom-radio__input" type="radio" checked name="2" value="hole" v-model="water_supply">
                  <div class="custom-radio__label">Скважина</div>
                </label>
                <label class="custom-radio main-form__item">
                  <input class="custom-radio__input" type="radio" name="2" value="well" v-model="water_supply">
                  <div class="custom-radio__label">Колодец</div>
                </label>
                <label class="custom-radio main-form__item">
                  <input class="custom-radio__input" type="radio" name="2" value="city" v-model="water_supply">
                  <div class="custom-radio__label">Городской / Централизованный водопровод</div>
                </label>
              </div>
              <div class="main-form__field">
                <div class="main-form__caption">Внешний вид воды</div>
                <div class="help_flex_modal">
                  <label class="custom-radio main-form__item">
                    <input class="custom-radio__input" type="radio" checked name="3" value="transparent" v-model="look_water">
                    <div class="custom-radio__label">Прозрачная</div>
                  </label>
                  <div class="custom-counter__helper water_look" v-on:click="show_help(helpData.one.title, helpData.one.text)"></div>
                </div>
                <div class="help_flex_modal">
                  <label class="custom-radio main-form__item">
                    <input class="custom-radio__input" type="radio" name="3" value="mudder" v-model="look_water">
                    <div class="custom-radio__label">Мутнеет/желтеет со временем</div>
                  </label>
                  <div class="custom-counter__helper water_look" v-on:click="show_help(helpData.two.title, helpData.two.text)"></div>
                </div>
                <div class="help_flex_modal">
                  <label class="custom-radio main-form__item">
                    <input class="custom-radio__input" type="radio" name="3" value="muddy" v-model="look_water">
                    <div class="custom-radio__label">Мутная/непрозрачная/желтая</div>
                  </label>
                  <div class="custom-counter__helper water_look" v-on:click="show_help(helpData.th.title, helpData.th.text)"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="section__row" id="people_count">
            <div class="main-form section__form">
              <div class="main-form__header">
                <h2 class="main-form__title">Расход воды</h2>
              </div>

              <div class="main-form__field">
                <div class="custom-counter main-form__item">
                  <div class="custom-counter__info">
                    <div class="custom-counter__title">Количество людей</div>
                    <div class="custom-counter__label">Постоянно проживающих</div>
                  </div>
                  <div class="custom-counter__data">
                    <div class="custom-counter__counter">
                      <button class="custom-counter__button minus" v-on:click="water_form.people--" v-bind:disabled="water_form.people<1">-</button>
                      <input class="custom-counter__input" type="number" disabled v-model.number="water_form.people">
                      <button class="custom-counter__button plus" v-on:click="water_form.people++" v-bind:disabled="water_form.people>7">+</button>
                    </div>
                  </div>
                </div>
                <!--<div class="custom-counter main-form__item">
                  <div class="custom-counter__info">
                    <div class="custom-counter__title">Нужна питьевая вода</div>
                  </div>
                  <div class="custom-counter__data">
                    <label class="custom-checkbox custom-counter__checkbox">
                      <input class="custom-checkbox__input" type="checkbox" v-model="water_form.water">
                      <div class="custom-checkbox__label">Да</div>
                    </label>
                  </div>
                </div>-->
              </div>

              <div class="water_form_warning" :class="{'show':waterFormWarning}">Чтобы подобрать систему, нужно выбрать количество постоянно проживающих людей.</div>
            </div>
          </div>

          <div class="section__row">
            <div class="main-form section__form">
              <div class="main-form__header">
                <h2 class="main-form__title" id="analyz_form">Анализ воды</h2>
<!--                <div class="main-form__label" v-on:click="showAnalyzeRequest">У меня нет анализа воды</div>-->
              </div>

              <div class="main-form__tabs">
                <div class="main-form__tabs-item js-tabs-button" v-on:click="showAnalysis('with_analysis')" :class="{'is-active':!withoutAnalysis}">Есть анализ воды</div>
                <div class="main-form__tabs-item js-tabs-button" v-on:click="showAnalysis('without_analysis')" :class="{'is-active':withoutAnalysis}">Нет анализа</div>
              </div>
              <transition name="analysis" mode="out-in">
                <div v-if="!withoutAnalysis" class="main-form__tab js-tab">
                  <div class="main-form__field">
                    <div class="custom-input js-date-input main-form__item" v-bind:class="{'error': inputCheck(analyze_form.date )}">
                      <input class="custom-input__hidden-input date_analyze" type="date" placeholder="0" min="2015-01-01" maxlength="10" :max="attributeDate" v-model="analyze_form.date">
                      <div class="custom-input__inner">
                        <div class="custom-input__label">Дата анализа воды <span>*</span>
                        </div>
                        <div class="custom-input__input">[[ analyze_form.date ]]</div>
                      </div>
                    </div>
                    <transition name="fade">
                      <div class="custom-input__date_warning" v-if="analyze_date" key="date_warning" >Анализ воды сделан более 6 месяцев назад, для более точного подбора оборудования желательно его обновить</div>
                    </transition>
                    <div class="custom-input main-form__item" v-bind:class="{'error': inputCheck(analyze_form.hydrogen )}">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('hydrogen')">Водородный показатель (PH), Уд. рН : <span>*</span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.hydrogen, 14, 'hydrogen')" maxlength="10" v-model="analyze_form.hydrogen" ref="hydrogen">
                    </div>
                    <div class="custom-input main-form__item two-row">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('salt')">Общее солесодержание (TDS/сухой остаток), мг/л : <span>*</span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.salt, 5000, 'salt')" maxlength="10" v-model="analyze_form.salt" ref="salt">
                    </div>
                    <div class="custom-input main-form__item">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('hardness')">Общая жесткость, мг-экв./л : <span>*</span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.hardness, 70, 'hardness')" maxlength="10" v-model="analyze_form.hardness" ref="hardness">
                    </div>
                    <div class="custom-input main-form__item">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('iron')">Общее железо, мг/л : <span>*</span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.iron, 100, 'iron')" maxlength="10" v-model="analyze_form.iron" ref="iron">
                    </div>
                    <div class="custom-input main-form__item">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('oxid')">Перманганатная окисляемость, мгО2/л : <span>*</span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" v-on:keyup="maxValue(analyze_form.oxid, 60, 'oxid')" min="0" maxlength="10" v-model="analyze_form.oxid" ref="oxid">
                    </div>
                    <div class="custom-input main-form__item">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('manganese')">Марганец, мг/л : <span>*</span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.manganese, 15, 'manganese')" maxlength="10" v-model="analyze_form.manganese" ref="manganese">
                    </div>
                    <div class="custom-input main-form__item">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('hydrosulfide')">Сероводород, мг/дм3 : <span>*</span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.hydrosulfide, 50, 'hydrosulfide')" maxlength="10" v-model="analyze_form.hydrosulfide" ref="hydrosulfide">
                    </div>
                    <div class="custom-input main-form__item">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('chroma')">Цветность, град. : <span>*</span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.chroma, 150, 'chroma')" maxlength="10" v-model="analyze_form.chroma" ref="chroma">
                    </div>
                    <div class="custom-input main-form__item" >
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('turbidity')">Мутность, ЕМФ : <span>*</span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.turbidity, 100, 'turbidity')" maxlength="10" v-model="analyze_form.turbidity" ref="turbidity">
                    </div>
                    <transition-group name="list">
                    <div class="custom-input main-form__item" v-show='showMore' key="custom_input_1">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('nitrits')">Нитриты, мг/дм3 : <span></span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.nitrits, 10, 'nitrits')" maxlength="10" v-model="analyze_form.nitrits" ref="nitrits">
                    </div>
                    <div class="custom-input main-form__item" v-show='showMore' key="custom_input_2">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('nitrats')">Нитраты, мг/дм3 : <span></span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.nitrats, 100, 'nitrats')" maxlength="10" v-model="analyze_form.nitrats" ref="nitrats">
                    </div>
                    <div class="custom-input main-form__item" v-show='showMore' key="custom_input_3">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('alkali')">Щелочность (общая), ммоль/дм3 : <span></span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.alkali, 5, 'alkali')" maxlength="10" v-model="analyze_form.alkali" ref="alkali">
                    </div>
                    <div class="custom-input main-form__item" v-show='showMore' key="custom_input_4">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('sulfate')">Сульфаты, мг/дм3 : <span></span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.sulfate, 100, 'sulfate')" maxlength="10" v-model="analyze_form.sulfate" ref="sulfate">
                    </div>
                    <div class="custom-input main-form__item" v-show='showMore' key="custom_input_5">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('sulfide')">Сульфиды, мг/дм3 : <span></span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.sulfide, 10, 'sulfide')" maxlength="10" v-model="analyze_form.sulfide" ref="sulfide">
                    </div>
                    <div class="custom-input main-form__item" v-show='showMore' key="custom_input_6">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('chloride')">Хлориды, мг/дм3 : <span></span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.chloride, 900, 'chloride')" maxlength="10" v-model="analyze_form.chloride" ref="chloride">
                    </div>
                    <div class="custom-input main-form__item" v-show='showMore' key="custom_input_7">
                      <div class="custom-input__inner">
                        <div class="custom-input__label" @click="focusInput('ammonium')">Амоний (ионы аммония), мг/дм3 : <span></span>
                        </div>
                      </div>
                      <input class="custom-input__hidden-input analyze_input" type="number" placeholder="0" min="0" v-on:keyup="maxValue(analyze_form.ammonium, 50, 'ammonium')" maxlength="10" v-model="analyze_form.ammonium" ref="ammonium">
                    </div>
                    <div class="main-form__header"><h2 class="main-form__title">Дополнительно</h2></div>
                    <div class="main-form__field last-field-hydrogen">
                      <div class="custom-counter flex-start main-form__item">
                        <div class="custom-counter__info">
                          <div class="custom-counter__title is-flex">У исходной воды присутствует запах сероводорода
                            <div class="helper custom-counter__helper" v-on:click="show_help(helpData.fi.title, helpData.fi.text)"></div>
                          </div>
                        </div>
                        <div class="custom-counter__data">
                          <label class="custom-checkbox custom-counter__checkbox">
                            <input class="custom-checkbox__input" type="checkbox" v-model="nSmellAnalysis">
                            <div class="custom-checkbox__label">Да</div>
                          </label>
                        </div>
                      </div>
                    </div>
                    </transition-group>
<!--                  <div class="main-form__load-more" v-on:click="showMoreFunc" v-show="!showMore">показать еще</div>-->
<!--                  <div class="main-form__load-more" v-on:click="showMoreFunc" v-show="showMore">скрыть</div>-->
                  </div>
                </div>

                <div v-else class="main-form__tab js-tab">
                    <div class="main-form section__form">
                      <div class="main-form__field">
                        <div class="custom-counter flex-start main-form__item">
                          <div class="custom-counter__info">
                            <div class="custom-counter__title is-flex">На нагревательных приборах (чайник, ТЭН) образуется
                              накипь
                              <div class="helper custom-counter__helper" v-on:click="show_help(helpData.fo.title, helpData.fo.text)"></div>
                            </div>
                          </div>
                          <div class="custom-counter__data">
                            <label class="custom-checkbox custom-counter__checkbox">
                              <input class="custom-checkbox__input" type="checkbox" v-model="nScale">
                              <div class="custom-checkbox__label">Да</div>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="main-form__field">
                        <div class="custom-counter flex-start main-form__item">
                          <div class="custom-counter__info">
                            <div class="custom-counter__title is-flex">У исходной воды присутствует запах сероводорода
                              <div class="helper custom-counter__helper" v-on:click="show_help(helpData.fi.title, helpData.fi.text)"></div>
                            </div>
                          </div>
                          <div class="custom-counter__data">
                            <label class="custom-checkbox custom-counter__checkbox">
                              <input class="custom-checkbox__input" type="checkbox" v-model="nSmell">
                              <div class="custom-checkbox__label">Да</div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                   <div class="main-form__text">Оптимальный выбор системы водоочистного оборудования может быть осуществлен только на основе проведенного химического анализа воды.</div>
                </div>
              </transition>

            </div>
            <button v-if="dynamicTitle" v-on:click='nextStep' class="btn main-form__button">Рассчитать стоимость</button>
            <button v-else v-on:click='nextStep' class="btn main-form__button">Подобрать систему</button>
          </div>
      </div>
      </section>
    </div>
  </transition-group>

  <transition-group name="fade" tag="section" class="section">
    <div v-if="current_step === 2">
      <div class="cont step-not-one"><div class="back-link" v-on:click="setStepOne">Назад к редактированию данных </div>
        <section class="section">
            <div class="section__header">
                <h2 class="section__title">Результат подбора</h2>
            </div>
            <div class="section__body">
                <div class="result-widget section__item">
                    <div class="result-widget__header" v-if="productPrice">
                        <div class="result-widget__title">[[ productName ]]</div>
                        <div class="result-widget__price">[[ productSale ]] ₽
                            <div class="result-widget__price-old">[[ productPrice]] ₽</div>
                        </div>
                    </div>
                    <div class="result-widget__header" v-else>
                        <div class="result-widget__title">[[ productName ]]</div>
                        <div class="result-widget__price" v-if="productSale">[[ productSale ]] ₽</div>
                    </div>
                    <div class="result-widget__body">
                        <div class="chars result-widget__chars" v-if="productImpurities.length > 0" v-bind:class="{ 'three_chars': productImpurities.length === 3 }">
                            <div class="chars__item" v-for="imp in productImpurities">[[ imp.name ]]
                                <img class="chars__icon" v-bind:src="imp.image" v-bind:alt="imp.name">
                            </div>
                        </div>
                        <div class="result-widget__list" v-if="productBenefits.length > 0 || productChars.length > 0">
                          <a class="result-widget__link" v-if="productBenefits.length > 0">Преимущества системы </a>
                          <div class="result-widget__link" v-on:click="active_button" v-if="productChars.length > 0">Характеристики</div>
                        </div>
                        <Splide :arrows="false" v-if="current_step === 2" :start="0">
                          <SplideSlide v-for="img in productImgs">
                            <img v-bind:src="img" v-bind:alt="productName">
                          </SplideSlide>
                        </Splide>
                        <div class="info result-widget__info" v-if="warning_device.length > 0 || water_rate_over || !productUrl || warning_analyze.length > 0">
                            <div class="info__list" v-if="water_rate_over || warning_device.length > 0 || warning_analyze.length > 0">
                                <div class="info__item" v-if="water_rate_over || warning_device.length > 0">Высокое водопотребление</div>
                                <div class="info__item" v-for="item in warning_device" v-bind:key="item">[[ item ]]</div>
                                <div class="info__item" v-for="item in warning_analyze" v-bind:key="item">[[ item ]]</div>
                            </div>
                            <div class="info__text">
                                <p v-if="water_rate_over || warning_device.length > 0">По результатам анализа, вы потребляете большое количество воды и требуется индивидуальное решение</p>
                                <p v-if="!productUrl || water_rate_over || warning_device.length > 0 || warning_analyze.length > 0">Отправьте заявку на консультацию и мы подберем для вас оптимальное решение</p>
                            </div>
                        </div>
                        <a class="btn result-widget__button" v-if="warning_device.length === 0 && warning_analyze.length == 0 && productUrl !== '' && !water_rate_over" :href="productUrl" target='_blank' v-on:click="dataLayerPush('2')">купить онлайн</a>
                        <div class="result-widget__consult-button" v-on:click="scrollConsultation">заказать консультацию</div>
                        <div class="info__text under_button" v-if="withoutAnalysis" >[[ eulaWithoutAnalysis ]]</div>
                        <div class="info__text under_button" v-else >[[ eulaWithAnalysis ]]</div>
                    </div>
                </div>
                <div class="feedback section__item" id="consultation_form">
                    <div class="feedback__header">
                        <h2 class="feedback__title result-title">Проконсультируйтесь со специалистом</h2>
                        <div class="feedback__caption">Для оптимального подбора оборудования и получения дополнительной информации закажите консультацию специалиста</div>
                    </div>
                  <div class="feedback__body">
                    <form class="feedback__form" action="#">
                      <div class="feedback__field">
                        <input class="feedback__input" v-bind:class="{'error': consultationCheck(consultation.name)}" type="text" placeholder="Имя" v-on:keyup="" v-model="consultation.name">
                        <label class="feedback__placeholder">Имя</label>
                      </div>
                      <div class="feedback__field">
                        <input class="feedback__input" v-bind:class="{'error': consultationCheck(consultation.phone)}" v-mask="{mask: '+7(999)999-99-99', showMaskOnHover: false}" type="tel" placeholder="Телефон" v-model="consultation.phone">
                        <label class="feedback__placeholder">Телефон</label>
                      </div>
                      <div class="feedback__field">
                        <input name="email" class="feedback__input" v-bind:class="{'error': mailCheck(consultation.email)}" type="email" placeholder="Email" v-model="consultation.email">
                        <label class="feedback__placeholder">Email</label>
                      </div>
                      <div class="feedback__field">
                        <input class="feedback__input" v-bind:class="{'error': consultationCheck(consultation.address)}" type="text" placeholder="Адрес объекта" v-model="consultation.address">
                        <label class="feedback__placeholder">Адрес объекта</label>
                      </div>
                      <div class="feedback__field feedback__file">
                         <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.5" d="M16.08 8.2875L9.18747 15.18C8.34309 16.0244 7.19786 16.4988 6.00372 16.4988C4.80959 16.4988 3.66436 16.0244 2.81997 15.18C1.97559 14.3356 1.50122 13.1904 1.50122 11.9962C1.50122 10.8021 1.97559 9.65688 2.81997 8.8125L9.71247 1.92C10.2754 1.35708 11.0389 1.04083 11.835 1.04083C12.6311 1.04083 13.3946 1.35708 13.9575 1.92C14.5204 2.48292 14.8366 3.24641 14.8366 4.0425C14.8366 4.83859 14.5204 5.60208 13.9575 6.165L7.05747 13.0575C6.77601 13.339 6.39427 13.4971 5.99622 13.4971C5.59818 13.4971 5.21643 13.339 4.93497 13.0575C4.65351 12.776 4.49539 12.3943 4.49539 11.9962C4.49539 11.5982 4.65351 11.2165 4.93497 10.935L11.3025 4.575" stroke="#2B1B35" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                         </svg>
                         <input type="file" name="file" id="feedback_file" class="feedback_file"  @change="checkFile">
                         <span class="feedback__file-help">Не более 5 Мб</span>
                         <transition-group  name="fade">
                          <span class="feedback__close_btn" v-if="fileAdded" v-on:click="deleteFile">
                            <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" class="octicon octicon-x">
                              <path d="M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"></path>
                            </svg>
                          </span>
                          <span class="feedback__file-size-error" v-if="fileErrorSize">Файл слишком большой, пожалуйста выберите файл размером не более 5 Мб</span>
                          <span class="feedback__file-format-error" v-if="fileErrorFormat">Неизвестный формат файла, пожалуйста выберите допустимый формат — JPG, JPEG, PNG, DOC, DOCX, RTF, XLS, PDF)</span>
                         </transition-group>
                      </div>
                      <div class="feedback__footer">
                        <div class="feedback__policy">
                            <div>
                                <label class="checkbox">
                                    <input v-model="eulaConfirm" type="checkbox" name="rule" style="margin-right:10px;">
                                        <span class="checkbox-title">Даю <a href="/personal-information" target="_blank">согласие</a> 
                                        на обработку моих персональных данных и подтверждаю, что я ознакомлен с 
                                        <a href="/privacy-policy" target="_blank">политикой обработки и защиты персональных данных</a>.</span>
                                </label>
                                <div class="input-field no-padding checkbox-error-message-div" v-if="eulaConfirmError">
                                    <span class="input-message checkbox-error-message">Укажите согласие с правилами</span>
                                </div>
                            </div>
                          <div class="commercial_ch_div">
                                <label class="checkbox">
                                    <input type="checkbox" name="commercial_ch">
                                        <span class="checkbox-title"><a target="_blank" href="/consent-to-advertising" class="usual-url">Даю согласие</a> на получение информационных и рекламных сообщений</span>
                                </label>
                            </div>
                        </div>
                        <div class="btn feedback__button" v-on:click="validate_consultation" :class="{'loading': loadingConsultation}">[[ buttonConsultationText ]]</div>
                      </div>
                    </form>
                  </div>
                </div>
            </div>
        </section>
      </div>
    </div>
  </transition-group>

  <transition-group name="fade" tag="section" class="section">
    <div v-if="current_step === 3">
      <div class="cont step-not-one"><div class="back-link" v-on:click="setStepOne">Назад к редактированию данных </div>
        <section class="section">
            <div class="section__header">
                <h2 class="section__title">Результат подбора</h2>
            </div>
            <div class="section__body">
                <div class="result-widget section__item">
                    <div class="result-widget__header">
                        <div class="result-widget__title">Система обратного осмоса</div>
                    </div>
                    <div class="result-widget__body">
                        <Splide :arrows="false">
                            <SplideSlide>
                              <img src="/resources/calc/assets/img/general/slider/osmos.png" alt="">
                            </SplideSlide>
                        </Splide>
                        <div class="info result-widget__info">
                            <div class="info__list">
                                <div v-if="water_rate_over || warning_device.length > 0">
                                  <div class="info__item">Высокое водопотребление</div>
                                  <div class="info__item" v-for="item in warning_device" v-bind:key="item">[[ item ]]</div>
                                  <div class="info__item" v-for="item in warning_analyze" v-bind:key="item">[[ item ]]</div>
                                </div>
                            </div>
                            <div class="info__text">
                                <p v-if="water_rate_over || warning_device.length > 0">По результатам анализа, вы потребляете большое количество воды и требуется индивидуальное решение</p>
                                <p>Отправьте заявку на консультацию и мы подберем для вас оптимальное решение</p>
                            </div>
                        </div>
                        <div class="btn result-widget__button" v-on:click="scrollConsultation">Заказать консультацию</div>
                        <div class="info__text under_button" v-if="withoutAnalysis" >[[ eulaWithoutAnalysis ]]</div>
                        <div class="info__text under_button" v-else >[[ eulaWithAnalysis ]]</div>
                    </div>
                </div>
                <div class="feedback section__item" id="consultation_form">
                    <div class="feedback__header">
                        <h2 class="feedback__title result-title">Проконсультируйтесь со специалистом</h2>
                        <div class="feedback__caption">Для оптимального подбора оборудования и получения дополнительной информации закажите консультацию специалиста</div>
                    </div>
                  <div class="feedback__body">
                    <form class="feedback__form" action="#">
                      <div class="feedback__field">
                        <input class="feedback__input" v-bind:class="{'error': consultationCheck(consultation.name)}" type="text" placeholder="Имя" v-on:keyup="" v-model="consultation.name">
                        <label class="feedback__placeholder">Имя</label>
                      </div>
                      <div class="feedback__field">
                        <input class="feedback__input" v-bind:class="{'error': consultationCheck(consultation.phone)}" v-mask="{mask: '+7(999)999-99-99', showMaskOnHover: false}" type="tel" placeholder="Телефон" v-model="consultation.phone">
                        <label class="feedback__placeholder">Телефон</label>
                      </div>
                      <div class="feedback__field">
                        <input name="email" class="feedback__input" v-bind:class="{'error': mailCheck(consultation.email)}" type="email" placeholder="Email" v-model="consultation.email">
                        <label class="feedback__placeholder">Email</label>
                      </div>
                      <div class="feedback__field">
                        <input class="feedback__input" v-bind:class="{'error': consultationCheck(consultation.address)}" type="text" placeholder="Адрес объекта" v-model="consultation.address">
                        <label class="feedback__placeholder">Адрес объекта</label>
                      </div>
                      <div class="feedback__field feedback__file">
                         <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.5" d="M16.08 8.2875L9.18747 15.18C8.34309 16.0244 7.19786 16.4988 6.00372 16.4988C4.80959 16.4988 3.66436 16.0244 2.81997 15.18C1.97559 14.3356 1.50122 13.1904 1.50122 11.9962C1.50122 10.8021 1.97559 9.65688 2.81997 8.8125L9.71247 1.92C10.2754 1.35708 11.0389 1.04083 11.835 1.04083C12.6311 1.04083 13.3946 1.35708 13.9575 1.92C14.5204 2.48292 14.8366 3.24641 14.8366 4.0425C14.8366 4.83859 14.5204 5.60208 13.9575 6.165L7.05747 13.0575C6.77601 13.339 6.39427 13.4971 5.99622 13.4971C5.59818 13.4971 5.21643 13.339 4.93497 13.0575C4.65351 12.776 4.49539 12.3943 4.49539 11.9962C4.49539 11.5982 4.65351 11.2165 4.93497 10.935L11.3025 4.575" stroke="#2B1B35" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                         </svg>
                         <input type="file" name="file" id="feedback_file" class="feedback_file"  @change="checkFile">
                         <span class="feedback__file-help">Не более 5 Мб</span>
                         <transition-group  name="fade">
                          <span class="feedback__close_btn" v-if="fileAdded" v-on:click="deleteFile">
                            <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" class="octicon octicon-x">
                              <path d="M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"></path>
                            </svg>
                          </span>
                          <span class="feedback__file-size-error" v-if="fileErrorSize">Файл слишком большой, пожалуйста выберите файл размером не более 5 Мб</span>
                          <span class="feedback__file-format-error" v-if="fileErrorFormat">Неизвестный формат файла, пожалуйста выберите допустимый формат — JPG, JPEG, PNG, DOC, DOCX, RTF, XLS, PDF)</span>
                         </transition-group>
                      </div>
                      <div class="feedback__footer">
                        <div class="feedback__policy">
                          <div>
                            <label class="checkbox">
                              <input v-model="eulaConfirm" type="checkbox" name="rule" style="margin-right:10px;">
                              <span class="checkbox-title">Даю <a href="/personal-information"
                                                                  target="_blank">согласие</a>
                                        на обработку моих персональных данных и подтверждаю, что я ознакомлен с
                                        <a href="/privacy-policy" target="_blank">политикой обработки и защиты персональных данных</a>.</span>
                            </label>
                            <div class="input-field no-padding eula-error checkbox-error-message-div" v-if="eulaConfirmError">
                              <span class="input-message checkbox-error-message">Укажите согласие с правилами</span>
                            </div>
                          </div>
                          <div class="commercial_ch_div">
                            <label class="checkbox">
                              <input type="checkbox" name="commercial_ch">
                              <span class="checkbox-title"><a target="_blank" href="/consent-to-advertising"
                                                              class="usual-url">Даю согласие</a> на получение информационных и рекламных сообщений</span>
                            </label>
                          </div>
                        </div>
                        <div class="btn feedback__button" v-on:click="validate_consultation" :class="{'loading': loadingConsultation}">[[ buttonConsultationText ]]</div>
                      </div>
                    </form>
                  </div>
                </div>
            </div>
        </section>
      </div>
    </div>
  </transition-group>
  <transition-group name="fade" tag="section" class="section">
    <div v-if="current_step === 4">
      <div class="cont step-not-one"><div class="back-link" v-on:click="setStepOne">Назад к редактированию данных </div>
        <section class="section">
            <div class="section__header">
                <h2 class="section__title">Результат подбора</h2>
            </div>
            <div class="section__body">
                <div class="feedback section__item" id="consultation_form">
                    <div class="feedback__header">
                        <h2 class="feedback__title result-title">Проконсультируйтесь со специалистом</h2>
                        <div class="feedback__caption">Возможно, проблема с водой не очевидна.<br>
                          Рекомендуем провести лабораторный анализ воды, он поможет понять её особенности и правильно подобрать умягчитель. Для получения дополнительной информации закажите консультацию специалиста.</div>
                    </div>
                  <div class="feedback__body">
                    <form class="feedback__form" action="#">
                      <div class="feedback__field">
                        <input class="feedback__input" v-bind:class="{'error': consultationCheck(consultation.name)}" type="text" placeholder="Имя" v-on:keyup="" v-model="consultation.name">
                        <label class="feedback__placeholder">Имя</label>
                      </div>
                      <div class="feedback__field">
                        <input class="feedback__input" v-bind:class="{'error': consultationCheck(consultation.phone)}" v-mask="{mask: '+7(999)999-99-99', showMaskOnHover: false}" type="tel" placeholder="Телефон" v-model="consultation.phone">
                        <label class="feedback__placeholder">Телефон</label>
                      </div>
                      <div class="feedback__field">
                        <input name="email" class="feedback__input" v-bind:class="{'error': mailCheck(consultation.email)}" type="email" placeholder="Email" v-model="consultation.email">
                        <label class="feedback__placeholder">Email</label>
                      </div>
                      <div class="feedback__field">
                        <input class="feedback__input" v-bind:class="{'error': consultationCheck(consultation.address)}" type="text" placeholder="Адрес объекта" v-model="consultation.address">
                        <label class="feedback__placeholder">Адрес объекта</label>
                      </div>
                      <div class="feedback__field feedback__file">
                         <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.5" d="M16.08 8.2875L9.18747 15.18C8.34309 16.0244 7.19786 16.4988 6.00372 16.4988C4.80959 16.4988 3.66436 16.0244 2.81997 15.18C1.97559 14.3356 1.50122 13.1904 1.50122 11.9962C1.50122 10.8021 1.97559 9.65688 2.81997 8.8125L9.71247 1.92C10.2754 1.35708 11.0389 1.04083 11.835 1.04083C12.6311 1.04083 13.3946 1.35708 13.9575 1.92C14.5204 2.48292 14.8366 3.24641 14.8366 4.0425C14.8366 4.83859 14.5204 5.60208 13.9575 6.165L7.05747 13.0575C6.77601 13.339 6.39427 13.4971 5.99622 13.4971C5.59818 13.4971 5.21643 13.339 4.93497 13.0575C4.65351 12.776 4.49539 12.3943 4.49539 11.9962C4.49539 11.5982 4.65351 11.2165 4.93497 10.935L11.3025 4.575" stroke="#2B1B35" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                         </svg>
                         <input type="file" name="file" id="feedback_file" class="feedback_file"  @change="checkFile">
                         <span class="feedback__file-help">Не более 5 Мб</span>
                         <transition-group  name="fade">
                          <span class="feedback__close_btn" v-if="fileAdded" v-on:click="deleteFile">
                            <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" class="octicon octicon-x">
                              <path d="M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"></path>
                            </svg>
                          </span>
                          <span class="feedback__file-size-error" v-if="fileErrorSize">Файл слишком большой, пожалуйста выберите файл размером не более 5 Мб</span>
                          <span class="feedback__file-format-error" v-if="fileErrorFormat">Неизвестный формат файла, пожалуйста выберите допустимый формат — JPG, JPEG, PNG, DOC, DOCX, RTF, XLS, PDF)</span>
                         </transition-group>
                      </div>
                      <div class="feedback__footer">
                        <div class="feedback__policy">
                          <div>
                            <label class="checkbox">
                              <input v-model="eulaConfirm" type="checkbox" name="rule" style="margin-right:10px;">
                              <span class="checkbox-title">Даю <a href="/personal-information"
                                                                  target="_blank">согласие</a>
                                        на обработку моих персональных данных и подтверждаю, что я ознакомлен с
                                        <a href="/privacy-policy" target="_blank">политикой обработки и защиты персональных данных</a>.</span>
                            </label>
                            <div class="input-field no-padding eula-error checkbox-error-message-div" v-if="eulaConfirmError">
                              <span class="input-message checkbox-error-message">Укажите согласие с правилами</span>
                            </div>
                          </div>
                          <div class="commercial_ch_div">
                            <label class="checkbox">
                              <input type="checkbox" name="commercial_ch">
                              <span class="checkbox-title"><a target="_blank" href="/consent-to-advertising"
                                                              class="usual-url">Даю согласие</a> на получение информационных и рекламных сообщений</span>
                            </label>
                          </div>
                        </div>
                        <div class="btn feedback__button" v-on:click="validate_consultation" :class="{'loading': loadingConsultation}">[[ buttonConsultationText ]]</div>
                      </div>
                    </form>
                  </div>
                </div>
            </div>
        </section>
      </div>
    </div>
  </transition-group>

  <transition-group name="fade" tag="div">
    <div v-if="current_step === 0">
      <div class="loader">
        <div class="bground-loading-progress" style="margin-bottom: 10px;">
          <div class="loader-ellipse"></div>
        </div>
        <div class="loader__text">[[ waitMessage ]]</div>
      </div>
    </div>
  </transition-group>
  <ModalStats v-show="show_modal_product" :chars="productChars" v-on:hideStats="hideStats"/>
  <ModalSuccess v-show="show_modal_success" v-on:hideSuccess="hideSuccess"/>
  <ModalHelp v-show="show_modal_help" v-on:hideHelp="hideHelp" :title="helpTitle" :text="helpText"/>
  </template>
  </transition-group>
  </div>
  `,
  data: () => ({
    type_house: 'vacation',
    water_supply: 'hole',
    look_water: 'transparent',
    current_step: 1,
    water_form: {
      people: 0,
      kitchen: 0,
      sink: 0,
      shower: 0,
      bathroom: 0,
      bidet: 0,
      toilet: 0,
      crane: 0,
      washing: 0,
      jacuzzi: 0,
      rain: 0,
      dishwasher: 0,
      water: false,
    },
    water_form_calculate: {
      people: 0,
      kitchen: 0,
      sink: 0,
      shower: 0,
      bathroom: 0,
      bidet: 0,
      toilet: 0,
      crane: 0,
      washing: 0,
      jacuzzi: 0,
      rain: 0,
      dishwasher: 0,
    },
    water_rate: 0,
    water_rate_over: false,
    analyze_form: {
      date: '',
      hydrogen: '',
      salt: '',
      hardness: '',
      iron: '',
      oxid: '',
      manganese: '',
      hydrosulfide: '',
      chroma: '',
      turbidity: '',
      nitrits: '',
      nitrats: '',
      alkali: '',
      sulfate: '',
      sulfide: '',
      chloride: '',
      ammonium: '',
    },
    analyze_form_errors: {
      date: false,
      hydrogen: false,
      salt: false,
      hardness: false,
      iron: false,
      oxid: false,
      manganese: false,
      hydrosulfide: false,
      chroma: false,
      turbidity: false,
    },
    analyze_form_validate: {
      hydrogen: false,
      salt: false,
      hardness: false,
      iron: false,
      oxid: false,
      manganese: false,
      hydrosulfide: false,
      chroma: false,
      turbidity: false,
      nitrits: false,
      nitrats: false,
      alkali: false,
      sulfate: false,
      sulfide: false,
      chloride: false,
      ammonium: false,
    },
    consultation: {
      name: '',
      phone: '',
      email: '',
      address: '',
    },
    consultation_error: {
      name: false,
      phone: false,
      email: false,
      address: false,
    },
    show_modal_product: false,
    show_modal_success: false,
    show_modal_help: false,
    to_osmos: false,
    warning_device: [],
    warning_analyze: [],
    showMore: false,
    analyze_date: false,
    waitMessage: '',
    isLoaded: false,
    productName: '',
    productUrl: '',
    productPrice: '',
    productSale: '',
    productImpurities: '',
    productImgs : '',
    productBenefits: '',
    productChars: [],
    errorValidate: false,
    confirmContinue: false,
    errorConsultValidate: false,
    loadingConsultation: false,
    canSendConsultation: true,
    buttonConsultationText: 'заказать консультацию',
    waterFormWarning: false,
    warningJacuzzi: false,
    warningRain: false,
    backIdeal: false,
    nScale: false,
    nSmell: false,
    nSmellAnalysis: false,
    withoutAnalysis: false,
    helpTitle: '',
    helpText: '',
    attributeDate: '',
    dynamicTitle: false,
    dynamicClass: '',
    fileAdded: false,
    fileErrorSize: false,
    fileErrorFormat: false,
    fileContain: null,
    helpData: {
      one: {title: 'Прозрачная', text: 'Вода внешне абсолютно прозрачная, не меняет свой вид в течение суток после набора в ёмкость.'},
      two: {title: 'Мутнеет/желтеет со временем', text: 'Вода при наборе в ёмкость прозрачная, но в течение суток становится рыжей, мутной, выпадает какой-либо осадок.'},
      th: {title: 'Мутная/непрозрачная/желтая', text: 'Вода мутная, непрозрачная, имеет рыжий оттенок уже во время набора в ёмкость.'},
      fo: {title: 'На нагревательных приборах (чайник, ТЭН) образуется накипь', text: 'Нагревательные элементы покрываются белым или бело-жёлтым налетом, на дне чайника образуются хлопья.'},
      fi: {title: 'У исходной воды присутствует запах сероводорода', text: 'Вода неприятно пахнет “тухлыми яйцами/мясом”.'},
    },
    eulaConfirm: false,
    eulaConfirmError: false,
    eulaWithoutAnalysis: 'Оптимальный выбор системы водоочистного оборудования может быть осуществлен только на основе проведенного химического анализа воды. Предложенные результаты являются рекомендацией. Покупатель самостоятельно знакомится с предоставленной продавцом информацией о товарах и делает свой выбор в пользу той или иной модели. При наличии вопросов, обратитесь за консультацией к нашим специалистам.',
    eulaWithAnalysis: 'Предложенные результаты являются рекомендацией. Покупатель самостоятельно знакомится с предоставленной продавцом информацией о товарах и делает свой выбор в пользу той или иной модели. При наличии вопросов, обратитесь за консультацией к нашим специалистам.',
  }),
  watch: {
    'analyze_form.date'(value) {
      let today = new Date();
      let inputDate = new Date(value);
      let diffmlsec = today.getTime() - inputDate.getTime();
      const halfyearmlsec = (1000 * 60 * 60 * 24 * 365)/2;
      this.analyze_date = diffmlsec > halfyearmlsec;
    },
    'consultation.name'(value) {
      const regex = /[A-Za-z0-9]/
      this.consultation.name = value.replace(regex, '');
    },
    'consultation.address'(value) {
      const regex = /[A-Za-z]/
      this.consultation.address = value.replace(regex, '');
    },
    'consultation.email'(value) {
      const regex = /[А-Яа-я]/
      this.consultation.email = value.replace(regex, '');
    },
    'water_form.jacuzzi'(value) {
      this.warningJacuzzi = value > 0;

    },
    'water_form.rain'(value) {
      this.warningRain = value > 0;
    },
    water_form: {
      handler(newVal) {
        if (this.waterFormWarning && newVal) {
          this.validate_water()
        }
      },
      deep:true,
    },
  },
  mounted() {
    setTimeout(()=> {
      document.getElementById('preLoader').setAttribute('style', 'opacity:0;');
    }, 300)
    setTimeout(()=> {
      document.getElementById('preLoader').setAttribute('style', 'opacity:0;height: 0;padding:0;');
      this.isLoaded = true;
    }, 600)
    let customInput = document.querySelectorAll(".custom-input"), dateInput = document.querySelectorAll(".js-date-input");
     customInput.forEach((function (item) {
         item.querySelector(".custom-input__hidden-input").addEventListener("keyup", (function () {
             // let thisVal =
             this.value.replace(/,/g, ".");
             // thisVal > 0.0 ? this.classList.add("is-active") : this.classList.remove("is-active")
         }))
     })), dateInput.forEach((function (item) {
         let input = item.querySelector(".custom-input__input");
         item.querySelector(".custom-input__hidden-input").addEventListener("change", (function () {
             let thisVal = this.value;
             input.innerHTML = thisVal, thisVal > 0 ? input.classList.add("is-active") : input.classList.remove("is-active")
         }))
     }));
     this.attributeDate = new Date().toISOString().split('T')[0];
     let params = (new URL(document.location)).searchParams;
     if (params.get("popup") == '1') {
       this.dynamicTitle = true;
       this.dynamicClass = 'without_padding';
     }
  },
  methods: {
    checkFile(event) {
      console.log(event.target.files);
      this.fileAdded = false;
      this.fileErrorSize = false;
      this.fileErrorFormat = false;
      this.fileContain = null;
      let trueFormat = ['pdf', 'xls', 'jpg', 'jpeg', 'png', 'rtf', 'doc', 'docx'];
      if (event.target.files.length === 1) {
        this.fileAdded = true;
      }
      if (this.fileAdded === true) {
        let file = event.target.files[0];
        let format = file.name.split('.');
        this.fileErrorSize = file.size >= 5242881;
        this.fileErrorFormat = trueFormat.indexOf(format[format.length - 1]) === -1;
      }
      if (this.fileAdded === true && this.fileErrorSize === false && this.fileErrorFormat === false){
        this.fileContain = event.target.files[0];
      }
    },
    deleteFile(){
      document.getElementById('feedback_file').value = null;
      this.fileErrorFormat = false;
      this.fileErrorSize = false;
      this.fileAdded = false;
      this.fileContain = null;
    },
    setZeroDate: function () {
      if (this.analyze_form.date === 0) {
        this.analyze_form.date = '';
      }
    },
    nextStep: function () {
        let water_validation = this.validate_water()
        for (let key in this.analyze_form) {
          // let no_required = ['nitrits', 'nitrats', 'alkali', 'sulfate', 'sulfide', 'chloride', 'ammonium'];
          let required = ['hydrogen', 'date']
          if (required.includes(key)) {
            this.analyze_form_errors[key] = this.analyze_form[key] === '' || this.analyze_form[key] === null;
          }
        }
        let errorCount = 0;
        for (let err in this.analyze_form_errors) {
          if (this.analyze_form_errors[err]) {
            errorCount++
          }
        }
        if (this.water_form.people === 0) {
              let form = document.getElementById('people_count');
              form.scrollIntoView({behavior: 'smooth'});
              return false
        }
        if (errorCount > 0 && this.withoutAnalysis === false) {
          this.errorValidate = true;
          this.scrollAnalyz();
        } else {
          this.errorValidate = false
        }
        if (water_validation) {
          return false
        }
        if (!this.errorValidate) {
          this.dataLayerPush('1');
          this.water_rate_over = this.water_form.people >= 6;
          this.current_step = 5;
          this.waitMessage = 'Подбираем оборудование';
          setTimeout(() => {this.current_step = 0}, 300)
          if (this.withoutAnalysis && !this.nScale && !this.nSmell && this.look_water !== 'muddy' && this.look_water !== 'mudder') {
            this.current_step = 5;
            setTimeout(() => {this.current_step = 4}, 1000)
            this.scrollUp();
          } else {
            this.validate_analyze();
            this.calc_water_rate();
            if (this.to_osmos) {
              this.current_step = 5;
              setTimeout(() => {this.current_step = 3}, 1000)
            } else {
              this.getProductInfo()
            }
            this.scrollUp();
          }
        } else {
            return false
        }
    },
    setStepOne: function () {
        //let url = window.location.href.split('?')[0]
        //let title = '';
        this.waitMessage = 'Возвращаемся к редактированию';
        //let get_response = {};
        //window.history.replaceState(get_response, title, url)
        this.current_step = 5;
        setTimeout(() => {this.current_step = 0}, 300)
        this.current_step = 5;
        setTimeout(() => {this.current_step = 1}, 1000)
        this.scrollUp();
        this.setZeroDate();
        this.to_osmos = false;
        this.productName = '';
        this.productUrl = '';
        this.productPrice = '';
        this.productSale = '';
        this.productImpurities = '';
        this.productImgs ='';
        this.productBenefits = '';
        this.productChars = '';
        this.backIdeal = false;
        this.eulaConfirm = false;
        this.eulaConfirmError = false;
        this.water_form_calculate = {
          people: 0,
          kitchen: 0,
          sink: 0,
          shower: 0,
          bathroom: 0,
          bidet: 0,
          toilet: 0,
          crane: 0,
          washing: 0,
          jacuzzi: 0,
          rain: 0,
          dishwasher: 0,
        };
        this.water_rate = 0;
        this.analyze_form_error = {
          date: false,
          hydrogen: false,
          salt: false,
          hardness: false,
          iron: false,
          oxid: false,
          manganese: false,
          hydrosulfide: false,
          chroma: false,
          turbidity: false,
        };
        this.analyze_form_validate = {
          hydrogen: false,
          salt: false,
          hardness: false,
          iron: false,
          oxid: false,
          manganese: false,
          hydrosulfide: false,
          chroma: false,
          turbidity: false,
          nitrits: false,
          nitrats: false,
          alkali: false,
          sulfate: false,
          sulfide: false,
          chloride: false,
          ammonium: false,
        };
        if (this.withoutAnalysis && this.nSmell) {
         this.analyze_form.hydrosulfide = 0;
        }
    },
    active_button: function () {
      this.show_modal_product = true;
      this.whenModalOpen();
    },
    show_success: function () {
      this.show_modal_success = true;
      this.whenModalOpen();
    },
    show_help: function (title, text) {
      this.helpTitle = title;
      this.helpText = text;
      this.show_modal_help = true;
      this.whenModalOpen();
    },
    hideHelp: function () {
      this.show_modal_help = false;
      this.whenModalClosed();
    },
    hideStats: function () {
      this.show_modal_product = false;
      this.whenModalClosed();
    },
    hideSuccess: function () {
      this.show_modal_success = false;
      this.whenModalClosed();
      this.consultation = {
        name: '',
        phone: '',
        email: '',
        address: '',
      };
      this.buttonConsultationText = 'Заказать консультацию';
      this.canSendConsultation = true
    },
    showAnalyzeRequest: function () {
      // eslint-disable-next-line no-undef
      $.fancybox.open({src: '#no-analyse'})
    },
    validate_water: function () {
      let error = false;
      let zero_input = 0
      for (let key in this.water_form) {
        if (this.water_form[key] === 0) {
          zero_input++;
        }
      }
      if (zero_input >= 12) {
          error = true
      }
      this.waterFormWarning = error;
      return error
    },
    validate_analyze: function () {
        this.warning_analyze = [];
        for (let key in this.analyze_form) {
          let value = this.analyze_form[key] !== ''? this.analyze_form[key] : 0;
          if (key === 'hydrogen' && !this.withoutAnalysis) {
            if (this.analyze_form[key] >= 6 && this.analyze_form[key] <= 9) {
              this.analyze_form_validate.hydrogen = true;
            } else {
              this.warning_analyze.push('Водородный показатель')
            }
          }
          if (key === 'salt' && !this.withoutAnalysis) {
            if (value <= 750) {
              this.analyze_form_validate.salt = true;
            } else {
              this.warning_analyze.push('Общее солесодержание TDS/сухой остаток')
            }
          }
          if (key === 'hardness' && !this.withoutAnalysis) {
            if (value <= 34) {
              this.analyze_form_validate.hardness = true;
            } else {
              this.warning_analyze.push('Общая жесткость')
            }
          }
          if (key === 'iron' && !this.withoutAnalysis) {
            if (value <= 14) {
              this.analyze_form_validate.iron = true;
            } else {
              this.warning_analyze.push('Общее железо')
            }
          }
          if (key === 'oxid' && !this.withoutAnalysis) {
            if (value <= 5) {
              this.analyze_form_validate.oxid = true;
            } else {
              this.warning_analyze.push('Перманганатная окисляемость')
            }
          }
          if (key === 'manganese' && !this.withoutAnalysis) {
            if (value <= 5) {
              this.analyze_form_validate.manganese = true;
            } else {
              this.warning_analyze.push('Марганец')
            }
          }
          if (key === 'hydrosulfide' && !this.withoutAnalysis) {
            if (value <= 1) {
              this.analyze_form_validate.hydrosulfide = true;
            } else {
              this.warning_analyze.push('Сероводород')
            }
          }
          if (key === 'chroma' && !this.withoutAnalysis) {
              this.analyze_form_validate.chroma = true;
              if (value >= 20) {
                  this.warning_analyze.push('Цветность - показания выше чем СанПин')
              }
          }
          if (key === 'turbidity' && !this.withoutAnalysis) {
              this.analyze_form_validate.turbidity = true;
              if (value >= 2.6) {
                  this.warning_analyze.push('Мутность - показания выше чем СанПин')
              }
          }
          if (key === 'nitrats' && !this.withoutAnalysis) {
            if (value <= 3) {
              this.analyze_form_validate.nitrats = true;
            } else {
              this.warning_analyze.push('Нитраты')
            }
          }
          if (key === 'nitrits' && !this.withoutAnalysis) {
            if (value <= 45) {
              this.analyze_form_validate.nitrits = true;
            } else {
              this.warning_analyze.push('Нитриты')
            }
          }
          if (key === 'alkali' && !this.withoutAnalysis) {
            if (value <= 0.25) {
              this.analyze_form_validate.alkali = true;
            } else {
              this.warning_analyze.push('Щелочи')
            }
          }
          if (key === 'sulfate' && !this.withoutAnalysis) {
            if (value <= 500) {
              this.analyze_form_validate.sulfate = true;
            } else {
              this.warning_analyze.push('Сульфаты')
            }
          }
          if (key === 'sulfide' && !this.withoutAnalysis) {
            if (value <= 3) {
              this.analyze_form_validate.sulfide = true;
            } else {
              this.warning_analyze.push('Сульфиды')
            }
          }
          if (key === 'chloride' && !this.withoutAnalysis) {
            if (value <= 350) {
              this.analyze_form_validate.chloride = true;
            } else {
              this.warning_analyze.push('Хлор')
            }
          }
          if (key === 'ammonium' && !this.withoutAnalysis) {
            if (value <= 2) {
              this.analyze_form_validate.ammonium = true;
            } else {
              this.warning_analyze.push('Аммоний')
            }
          }
        }
        for (let item in this.analyze_form_validate) {
           if (!this.analyze_form_validate[item] && !this.withoutAnalysis) {
             this.to_osmos = true;
           }
           if (this.look_water === 'muddy') {
             this.to_osmos = true
           }
        }
    },
    calc_water_rate: function () {
      let fieldsList = [
        { key: "jacuzzi", value: this.water_form.jacuzzi, count: 0.8},
        { key: "rain", value: this.water_form.rain, count: 0.4 },
        { key: "bathroom", value: this.water_form.bathroom, count: 0.2 },
        { key: "shower", value: this.water_form.shower, count: 0.15 },
        { key: "crane", value: this.water_form.crane, count: 0.15 },
        { key: "sink", value: this.water_form.sink, count: 0.12 },
        { key: "toilet", value: this.water_form.toilet, count: 0.1 },
        { key: "kitchen", value: this.water_form.kitchen, count: 0.1 },
        { key: "bidet", value: this.water_form.bidet, count: 0.08 },
      ];
      this.warning_device = [];
      let priority = this.calc_water_rate_body(fieldsList)
      this.water_rate = priority * 3.6;
    },
    calc_water_rate_body(fieldsList) {
      let peopleCount = this.water_form.people;
      // let priority = 0;
      for (let i = 0; i < fieldsList.length; i++) {
        if (peopleCount <= 0) {
          break;
        }
        let fieldValue = fieldsList[i].value;
        // let fieldCount = fieldsList[i].count;
        if (peopleCount < fieldValue) {
          fieldValue = peopleCount
        }
        if (fieldValue > 0) {
          // priority += (fieldValue * fieldCount);
          peopleCount = peopleCount - fieldValue;
        }
      }

      // if (this.water_form.dishwasher > 0 || this.water_form.washing > 0) {
      //   priority += this.water_form.washing * 0.18;
      //   priority += this.water_form.dishwasher * 0.1;
      // }
      if (this.water_form.jacuzzi > 0) {
           this.warning_device.push('Джакузи')
      }
      if (this.water_form.rain > 0) {
           this.warning_device.push('Тропический душ')
      }

      return 0.4
    },
    scrollConsultation: function () {
      let form = document.getElementById('consultation_form');
      form.scrollIntoView({behavior: 'smooth'});
    },
    validate_consultation: function () {
      let errors = 0;
      for (let key in this.consultation) {
        if (this.consultation[key] === '') {
          this.consultation_error[key] = true;
          errors = errors + 1;
        }
      }
      let lastChar = this.consultation.phone[this.consultation.phone.length - 1];
      if (lastChar === '_') {
        this.consultation_error.phone = true;
        errors = errors + 1;
      }
      if (this.eulaConfirm === true) {
        this.eulaConfirmError = false
      } else {
        this.eulaConfirmError = true
        errors = errors + 1;
      }
      if (this.fileAdded === true){
        if (!this.fileErrorFormat && !this.fileErrorSize) {
          this.errorConsultValidate = false;
        } else {
          errors = errors + 1;
        }
      }
      let emailcheck = this.emailValidate(this.consultation.email)
      if (emailcheck && errors === 0) {
        this.errorConsultValidate = false;
        this.sendConsultations()
      } else {
        this.errorConsultValidate = true;
        return false;
      }
    },
    sendConsultations: function () {
      if (this.canSendConsultation) {
        this.loadingConsultation = true;
        this.buttonConsultationText = 'Загрузка...'
        this.canSendConsultation = false;
        let water_rate_over = false;
        if(this.warning_device.length > 0 || this.water_rate_over) {
            water_rate_over = true;
        }
        let smell = this.nSmellAnalysis
        if (this.withoutAnalysis) {
            smell = this.nSmell
        }
        let formData = new FormData();
        formData.append('operation', 'consultation_form');
        formData.append('name', this.consultation.name);
        formData.append('phone', this.consultation.phone);
        formData.append('email', this.consultation.email);
        formData.append('address', this.consultation.address);
        formData.append('type_house', this.type_house);
        formData.append('water_supply', this.water_supply);
        formData.append('look_water', this.look_water);
        formData.append('water_rate', this.water_rate);
        formData.append('product_name', this.productName);
        formData.append('product_url', this.productUrl);
        formData.append('without_analysis', this.withoutAnalysis);
        formData.append('scale', this.nScale);
        formData.append('smell', smell);
        formData.append('to_osmos', this.to_osmos);
        formData.append('water_rate_over', water_rate_over);
        formData.append('popup', this.dynamicTitle);
        formData.append('file', this.fileContain);
        for (const key in this.analyze_form) {
          if (Object.hasOwnProperty.call(this.analyze_form, key)) {
            formData.append(`analyze_form[${key}]`, this.analyze_form[key]);
          }
        }
        for (const key in this.water_form) {
          if (Object.hasOwnProperty.call(this.water_form, key)) {
            formData.append(`water_form[${key}]`, this.water_form[key]);
          }
        }
        axios({
          method: 'POST',
          url: API_URL,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Basic dGVzdDplektfe25WbCEpM2Y=',
          }
        })
        .then(data => {
          setTimeout(() => {if (data.data['result'] === 0 && data.data['success'] === true) {
            this.loadingConsultation = false;
            this.buttonConsultationText = 'Отправлено';
            this.dataLayerPush('3');
            this.show_success()
          } else {
            this.loadingConsultation = false;
            this.buttonConsultationText = 'Возникла ошибка, повторите позже';
            setTimeout(() => {this.buttonConsultationText = 'Заказать консультацию'; this.canSendConsultation = true}, 2000)
          }}, 1000)
        }).catch(err => {
            if (err) {
              this.loadingConsultation = false;
              this.buttonConsultationText = 'Возникла ошибка, повторите позже';
            }
            setTimeout(() => {this.buttonConsultationText = 'Заказать консультацию'; this.canSendConsultation = true}, 2000)
        })
      }
    },
    scrollUp: function () {
      // eslint-disable-next-line no-undef
        $('html, body').animate({scrollTop: 0},500);
    },
    scrollAnalyz: function () {
      let form = document.getElementById('analyz_form');
      form.scrollIntoView({behavior: 'smooth'});
    },
    getProductInfo: function () {
        //let url = window.location.href.split('?')[0] + '?zh=' + this.analyze_form.hardness + '&fer=' + this.analyze_form.iron +
        //          '&mg=' + this.analyze_form.manganese + '&hs=' + this.analyze_form.hydrosulfide + '&w=' + this.water_rate;
        //let title = '';
        //let get_response = {}
        //window.history.replaceState(get_response, title, url)
       for (let i in this.analyze_form) {
         if (this.analyze_form[i] === '') {
           this.analyze_form[i] = 0;
         }
       }
       if (this.withoutAnalysis && this.nSmell) {
         this.analyze_form.hydrosulfide = 1;
       }
       let smell = this.nSmellAnalysis;
       if (this.withoutAnalysis) {
         smell = this.nSmell;
       }
       let params = {
            'type_house': this.type_house,
            'water_supply': this.water_supply,
            'look_water': this.look_water,
            'water_form': this.water_form,
            'water_rate': this.water_rate,
            'analyze_form': this.analyze_form,
            'without_analysis': this.withoutAnalysis,
            'scale': this.nScale,
            'smell': smell,
            'city_id': document.getElementById('calc').getAttribute('data-city-id'),
            'from_im' : document.getElementById('calc').getAttribute('data-from-im'),
        }
        axios({
          method: 'POST',
          url: API_URL,
          data: params,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic dGVzdDplektfe25WbCEpM2Y='
          }
        })
            .then(data => {
              if (data.data['success'] === true && data.data['result'] === 0) {
                this.productName = data.data['product']['name'];
                this.backIdeal = data.data['ideal'] === true;
                this.productUrl = this.valuesCheck(data.data['product']['url']) ? data.data['product']['url'] : '';
                this.productPrice = this.valuesCheck(data.data['product']['base_price']) ? data.data['product']['base_price'] : '';
                this.productSale = this.valuesCheck(data.data['product']['final_price']) ? data.data['product']['final_price'] : '';
                this.productImpurities = this.valuesCheck(data.data['product']['impurities']) ? data.data['product']['impurities'] : [];
                this.productImgs = this.valuesCheck(data.data['product']['gallery']) ? data.data['product']['gallery'] : '';
                this.productBenefits = this.valuesCheck(data.data['product']['benefits']) ? data.data['product']['benefits'] : [];
                this.productChars = this.valuesCheck(data.data['product']['chars']) ? data.data['product']['chars'] : [];
              } else if (data.data['success'] === false && data.data['result'] === 404) {
                this.to_osmos = true
              } else if (data.data['success'] === false && data.data['result'] === 1) {
                this.to_osmos = true
              } else if (data.data['success'] === false && data.data['result'] === 2) {
                this.globalErrorMsg = 'Ошибка в параметрах'; // TODO: уточнить по глобальным ошибкам.
                this.setStepOne();
                this.to_osmos = false;
              } else {
                this.to_osmos = true
              }
              if (this.to_osmos) {
                this.current_step = 5;
                setTimeout(() => {this.current_step = 3}, 1000)
              } else {
                this.current_step = 5;
                setTimeout(() => {this.current_step = 2}, 1000)
              }
              // if (this.backIdeal === true) {
              //   this.warning_device = [];
              //   this.water_rate_over = false;
              // }
              // else {
              //   this.water_rate_over = true;
              // }
            }).catch(err => {
                console.log(err);
                this.current_step = 5;
                setTimeout(() => {this.current_step = 1}, 1000)
              })
    },
    showMoreFunc: function () {
        this.showMore = !this.showMore;
    },
    gotoProduct: function () {
        if (this.productUrl !== '') {
          window.open(this.productUrl, "_blank");
        }
    },
    focusInput(refName) {
      this.$refs[refName].focus();
    },
    valuesCheck(value) {
      if (value !== undefined && value !== '' && value !== null) {
        return value
      } else {
        return false
      }
    },
    inputCheck(value) {
      if (this.errorValidate) {
        if (value !== undefined && value !== '' && value !== null) {
          return false
        } else {
          return true
        }
      }
    },
    consultationCheck(value) {
      if (this.errorConsultValidate) {
       return !(value !== undefined && value !== '' && value !== null && value[value.length - 1] !== '_');
      } else {return false}
    },
    mailCheck(value) {
      if (this.errorConsultValidate) {
        let re = /^\S+@\S+\.\S+$/;
        return !re.test(value);
      }
    },
    emailValidate(value) {
      return !this.mailCheck(value)
    },
    maxValue(value, max, key) {
      if (value > max) {
        this.analyze_form[key] = max;
      }
    },
    phoneMask(x, pattern, mask) { //TODO: Проверить актуальность некоторых функций после всех изменений.
      var strippedValue = x.replace(/[^0-9]/g, "");
      var chars = strippedValue.split('');
      var count = 0;

      var formatted = '';
      for (var i=0; i<pattern.length; i++) {
        const c = pattern[i];
        if (chars[count]) {
          if (/\*/.test(c)) {
            formatted += chars[count];
            count++;
          } else {
            formatted += c;
          }
        } else if (mask) {
          if (mask.split('')[i])
            formatted += mask.split('')[i];
        }
      }
      return formatted;
    },
    whenModalOpen: function () {
      document.body.classList.add("modal-show");
    },
    whenModalClosed: function () {
      document.body.classList.remove("modal-show");
    },
    showAnalysis: function (type) {
      this.withoutAnalysis = type !== 'with_analysis';
    },
    dataLayerPush: function (step) {
      if (window.dataLayer === undefined || window.dataLayer === 'undefined') {
         window.dataLayer = [];
      }
      if (step === '1') {
        window.dataLayer.push ({'event':'send_form', 'form_name':'calc_podbor_system'});
      }
      else if (step === '2') {
        window.dataLayer.push ({'event':'click_button', 'form_name':'calc_buy_online'});
      }
      else if (step === '3') {
        window.dataLayer.push ({'event':'send_form', 'form_name':'calc_concultation'});
      }
    }

  },

}
</script>

<style>
.last-field-hydrogen {
  margin-bottom: 24px !important;
}
.water_look {
    margin-left: 4px;
    display: inline-flex;
    position: relative;
    flex-shrink: 0;
    margin-top: 2px;
    width: 16px;
    height: 20px;
    background-image: url(data:image/svg+xml,%3Csvg width=%2716%27 height=%2720%27 viewBox=%270 0 16 20%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg opacity=%270.2%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.34315 3.34315C3.84344 1.84285 5.87827 1 8 1C10.1217 1 12.1566 1.84285 13.6569 3.34315C15.1571 4.84344 16 6.87827 16 9C16 11.1217 15.1571 13.1566 13.6569 14.6569C12.1566 16.1571 10.1217 17 8 17C5.87827 17 3.84344 16.1571 2.34315 14.6569C0.842855 13.1566 0 11.1217 0 9C0 6.87827 0.842855 4.84344 2.34315 3.34315ZM8 15C9.5913 15 11.1174 14.3679 12.2426 13.2426C13.3679 12.1174 14 10.5913 14 9C14 7.4087 13.3679 5.88258 12.2426 4.75736C11.1174 3.63214 9.5913 3 8 3C6.4087 3 4.88258 3.63214 3.75736 4.75736C2.63214 5.88258 2 7.4087 2 9C2 10.5913 2.63214 12.1174 3.75736 13.2426C4.88258 14.3679 6.4087 15 8 15ZM7 6.333C7 5.78072 7.44772 5.333 8 5.333H8.007C8.55928 5.333 9.007 5.78072 9.007 6.333C9.007 6.88528 8.55928 7.333 8.007 7.333H8C7.44772 7.333 7 6.88528 7 6.333ZM7 8H9C9 8 9 8.78899 9 9V11.667C9 11.9342 9 12.667 9 12.667H7C7 12.667 7 12.2193 7 11.667V9C7 8.44772 7 8 7 8Z%27 fill=%27%232B1B35%27/%3E%3C/g%3E%3C/svg%3E%0A);
}
.custom-radio.flex_modal {
  display: flex;
}
.help_flex_modal{
  display: flex;
}
.water_form_warning {
  padding: 0;
  color: red;
  transition: all .6s;
  opacity: 0;
  visibility: hidden;
  max-height: 0
}

.water_form_warning.show {
  padding: 10px 0 20px 0;
  opacity: 1;
  visibility: visible;
  max-height: 80px
}

body.modal-show {
  overflow: hidden
}

.step-not-one {
  padding-top: 20px !important
}

.feedback__button.loading {
  background-image: linear-gradient(137deg, #2960cc, #fff 1000px, #2960cc 2000px);
  background-size: 3250px;
  animation: shine-lines 1.6s linear infinite
}

@keyframes shine-lines {
  0% {
    background-position: -100px
  }

  40%, to {
    background-position: 450px
  }
}

.date_analyze::-webkit-calendar-picker-indicator {
  width: 100%;
  height: 100%;
  min-height: 24px
}

.custom-input__hidden-input.date_analyze {
  padding: 0
}

.custom-input__date_warning {
  line-height: 12px;
  font-size: 11px;
  padding: 0 4px 16px;
  font-weight: 400
}

.splide__arrows--ltr {
  visibility: hidden;
  opacity: 0;
  position: absolute
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}

.fade-enter-from, .fade-leave-to {
  opacity: 0
}

.list-enter-active, .list-leave-active {
  transition: all .5s ease-in;
  overflow: hidden;
  height: 37px
}

.list-enter-from, .list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
  height: 0;
  margin-bottom: 0 !important;
  padding: 0 !important;
  border: 0
}

.analysis-enter-active, .analysis-leave-active {
  transition: all .5s ease-in;
  overflow: hidden;
  max-height: 500px;
}
.analysis-leave-from {
  opacity: 0.5;
}
.analysis-enter-from, .analysis-leave-to {
  opacity: 0;
  transform: translateY(-30px);
  margin-bottom: 0 !important;
  padding: 0 !important;
  border: 0;
  max-height: 150px;
}


/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%
}

body {
  margin: 0
}

main {
  display: block
}

h1 {
  font-size: 2em;
  margin: .67em 0
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible
}

pre {
  font-family: monospace, monospace;
  font-size: 1em
}

a {
  background-color: transparent
}

abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted
}

b, strong {
  font-weight: bolder
}

code, kbd, samp {
  font-family: monospace, monospace;
  font-size: 1em
}

small {
  font-size: 80%
}

sub, sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline
}

sub {
  bottom: -.25em
}

sup {
  top: -.5em
}

img {
  border-style: none
}

button, input, optgroup, select, textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0
}

button, input {
  overflow: visible
}

button, select {
  text-transform: none
}

[type=button], [type=reset], [type=submit], button {
  -webkit-appearance: button
}

[type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner, button::-moz-focus-inner {
  border-style: none;
  padding: 0
}

[type=button]:-moz-focusring, [type=reset]:-moz-focusring, [type=submit]:-moz-focusring, button:-moz-focusring {
  outline: 1px dotted ButtonText
}

fieldset {
  padding: .35em .75em .625em
}

legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal
}

progress {
  vertical-align: baseline
}

textarea {
  overflow: auto
}

[type=checkbox], [type=radio] {
  box-sizing: border-box;
  padding: 0
}

[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button {
  height: auto
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit
}

details {
  display: block
}

summary {
  display: list-item
}

[hidden], template {
  display: none
}

* {
  box-sizing: border-box
}

:after, :before {
  box-sizing: inherit
}

body {
  font-family: var(--font-family-rg), sans-serif;
  color: #2b1b35
}

body.is-modal {
  overflow: hidden;
  position: relative
}

.cont {
  margin: 0 auto;
  max-width: 544px;
  width: 100%;
  padding: 30px 12px 0 12px
}

input::-webkit-inner-spin-button, input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0
}

.back-link {
  display: inline-flex;
  align-items: center;
  margin-bottom: 25px;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: inherit;
  text-decoration: none;
  transition: opacity .3s ease;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none
}

.back-link:hover {
  opacity: .7
}

.back-link:before {
  content: "";
  margin-right: 20px;
  margin-top: 2px;
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  display: block;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.294 5.5H12M7.47 1.125 2.295 5.569l.014.011L7.31 9.875' stroke='%232B1B35' stroke-width='1.75' stroke-miterlimit='10'/%3E%3C/svg%3E")
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 1.35px;
  text-transform: uppercase;
  text-decoration: none;
  color: #fff;
  border: 0;
  background: linear-gradient(180deg, #2960cc, rgba(18, 72, 178, 0)), #1248b2;
  box-shadow: 0 5px 10px rgba(0, 56, 166, .4);
  border-radius: 100px;
  cursor: pointer;
  transition: background .3s ease;
  outline: 0
}

.btn:hover {
  background: #073fab
}

.btn.is-secondary {
  color: #1248b2;
  transition: opacity .3s ease;
  background: #f1f6ff;
  box-shadow: none
}

.btn.is-secondary:hover {
  background: #f1f6ff;
  opacity: .7
}

.chars {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}

.chars__item {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  font-size: 10px;
  line-height: 12px;
  padding-left: 6px;
  margin-right: 12px;
  margin-left: -6px;
  margin-bottom: 6px;
  border-left: 1px solid #e4e7eb;
}

.chars__item:last-child {
  margin-right: 0;
  padding-right: 0;
  border: 0
}

.chars__icon {
  margin-right: 4px
}

.custom-checkbox {
  display: block;
  cursor: pointer
}

.custom-checkbox__input {
  display: none
}

.custom-checkbox__input:checked + .custom-checkbox__label:before {
  opacity: 1
}

.custom-checkbox__label {
  display: flex;
  position: relative;
  font-size: 14px;
  line-height: 17px;
  color: #2b1b35;
  transition: opacity .1s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none
}

.custom-checkbox__label:before {
  content: "";
  width: 16px;
  height: 16px;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;
  transition: opacity .1s ease;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' rx='3' fill='%231248B2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.716 4.278c.379.372.379.973 0 1.345l-6.228 6.099a.985.985 0 0 1-1.373 0l-2.83-2.773a.937.937 0 0 1 0-1.344.985.985 0 0 1 1.372 0l2.144 2.1 5.542-5.427a.985.985 0 0 1 1.373 0Z' fill='%23fff'/%3E%3C/svg%3E")
}

.custom-checkbox__label:after {
  content: "";
  display: block;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-left: 12px;
  border: 1px solid #c0bbc3;
  border-radius: 3px
}

.custom-checkbox__label:hover {
  opacity: .7
}

.custom-counter {
  display: flex;
  align-items: center;
  justify-content: space-between
}

.custom-counter__info {
  max-width: 345px;
  padding-right: 20px
}

.custom-counter__title {
  font-size: 14px;
  line-height: 17px
}

.custom-counter__label {
  margin-top: 4px;
  opacity: .8;
  font-size: 10px;
  line-height: 12px
}

.custom-counter__counter {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 104px;
  background: rgba(228, 231, 235, .5);
  border: 1px solid rgba(228, 231, 235, .5);
  border-radius: 50px;
  transition: border .6s
}

.custom-counter__counter.error {
  border: 1px solid #ff0e0e
}

.custom-counter__button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  line-height: 32px
}

.custom-counter__button, .custom-counter__input {
  background: 0;
  padding: 0;
  width: 33.33%;
  border: 0;
  text-align: center
}
.custom-counter__helper {
    cursor: pointer;
    transition: opacity 0.3s ease;
    opacity: 1;
}
.custom-counter__helper:hover{
    opacity: 0.6;
}
.custom-counter__input {
  color: #000 !important
}

.custom-input {
  display: flex;
  width: 100%;
  position: relative;
  border: 1px solid #e4e7eb;
  border-radius: 6px;
  transition: height .3s, border .1s
}

.custom-input:not(.error):hover {
  border-color: #0049bc80
}

.custom-input:not(.error):focus-within {
  border-color: #1248b2
}

.custom-input.error {
  border-color: #ee005a
}

.custom-input.error:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .25)
}

.custom-input.js-date-input:before {
  content: "";
  position: absolute;
  right: 12px;
  top: 8px;
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='20' height='20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.833 3.332H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V5c0-.92-.746-1.667-1.667-1.667Z' stroke='%238CA7DC' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13.333 1.668v3.333M13.333 11.668v.833M10 11.668v.833M6.667 1.668v3.333M6.667 11.668v.833' stroke='%238CA7DC' stroke-width='1.5' stroke-linecap='square' stroke-linejoin='round'/%3E%3Cpath d='M2.5 8.332h15' stroke='%238CA7DC' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")
}

.custom-input__label {
  font-size: 12px;
  line-height: 16px;
  color: #2b1b35;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  opacity: .5;
  cursor: pointer;
  transition: opacity .1s ease
}

.custom-input__input {
  padding: 10px 12px
}

.custom-input__label {
  padding: 10px 0 10px 12px
}

.custom-input__hidden-input {
  padding: 10px 0 10px 0
}

.custom-input__label span {
  display: inline-block;
  margin: 0 5px 0 0;
  color: #ee005a;
  opacity: 1
}

.custom-input__inner {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: auto;
  flex: 0 0 auto;
  min-height: 36px
}

.custom-input.js-date-input .custom-input__inner {
  width: 100%
}

.custom-input__input {
  float: left;
  font-size: 12px;
  line-height: 16px;
  color: #2b1b35;
  opacity: .5
}

.custom-input__input.is-active {
  opacity: 1
}

.custom-input__hidden-input {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  opacity: 0
}

.custom-input__hidden-input:not(:-moz-placeholder-shown):not(.date_analyze) {
  opacity: 1
}
.custom-input__hidden-input.date_analyze + .custom-input__inner .custom-input__input, .custom-input__hidden-input:not(:placeholder-shown):not(.date_analyze) {
  opacity: 1
}
.custom-input__hidden-input:focus + .custom-input__inner {
  border-color: #1248b2
}

.custom-input__hidden-input:focus + .custom-input__inner .custom-input__label, .custom-input__hidden-input:focus:focus:not(.date_analyze) {
  opacity: 1
}
.custom-input__hidden-input:focus + .custom-input__inner .custom-input__label {
  cursor: pointer
}

.custom-input__hidden-input:hover + .custom-input__inner .custom-input__label, .custom-input__label:hover {
  opacity: .8
}

.custom-radio {
  display: block;
  cursor: pointer
}

.custom-radio__input {
  display: none
}

.custom-radio__input:checked + .custom-radio__label:before {
  border: 4px solid #164cb5
}

.custom-radio__label {
  display: flex;
  font-size: 14px;
  line-height: 17px;
  color: #2b1b35;
  transition: opacity .3s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none
}

.custom-radio__label:before {
  content: "";
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
  margin-right: 12px;
  border-radius: 50%;
  border: 1px solid #c0bbc3;
  transition: border .1s ease-in
}

.custom-radio__label:hover {
  opacity: .7
}

.feedback {
  padding: 24px 12px;
  border-radius: 8px;
  background: #f5f6f7;
  margin-top: 28px;
  margin-bottom: 28px;
}

.feedback__header {
  margin-bottom: 20px
}

.feedback__title {
  font: 20px/24px var(--font-family-sm);
  font-weight: 600;
  text-align: center
}

.feedback__list {
  margin: 0;
  padding: 0;
  list-style-type: none
}

.feedback__list li {
  display: flex;
  align-items: center;
  font: 14px/17px var(--font-family-sm);
  font-weight: 600;
  margin-bottom: 12px
}

.feedback__list li:last-child {
  margin-bottom: 0
}

.feedback__list li:before {
  display: block;
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1248b2;
  margin-top: 4px;
  margin-right: 8px;
  flex-shrink: 0
}

.feedback__label {
  margin-top: 8px;
  font-size: 10px;
  line-height: 12px
}
.feedback__field {
  position: relative;
}
.feedback__placeholder {
    position: absolute;
    pointer-events: none;
    top: 11px;
    left: 12px;
    font-size: 14px;
    line-height: 17px;
    color: #2B1B35;
    opacity: 0.5;
    white-space: nowrap;
    overflow: hidden;
    transition: .3s;
    box-sizing: border-box;
}
.feedback__input:focus ~ .feedback__placeholder,
.feedback__input:not(:placeholder-shown) ~ .feedback__placeholder {
  top: 5px;
  font-size: 10px;
  line-height: 12px;
}
.feedback__input::placeholder {
  opacity: 0!important;
}
.feedback__caption {
  margin-top: 20px;
  font-size: 12px;
  line-height: 16px
}

.feedback__input {
  margin-bottom: 16px;
  padding: 10px 12px 0px;
  width: 100%;
  height: 40px;
  background: #fff;
  border: 1px solid #e4e7eb;
  border-radius: 6px;
  outline: none;
  box-shadow: none;
  transition: .5s;
  font-size: 14px;
  line-height: 17px;
  color: #2b1b35
}
.feedback__input.error {
  border: 1px solid red
}
.feedback__input.focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .25)
}
.feedback__input:focus {
  border-color: #1248b2;
  transition: .5s
}
.feedback__input:last-child {
  margin-bottom: 0
}

.feedback__input::-moz-placeholder {
  opacity: .5
}

.feedback__input::placeholder {
  opacity: .5
}
.feedback__footer {
  margin-top: 20px
}
.feedback__policy {
  margin-top: 20px;
  font-size: 10px;
  line-height: 12px
}
.feedback__policy a {
  color: #1248b2;
  text-decoration: none
}

.info__list {
  margin-bottom: 12px
}
.info__item {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 16px
}

.info__item:before {
  content: "";
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
  margin-right: 6px;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.657 13.657A8 8 0 1 1 2.343 2.342a8 8 0 0 1 11.314 11.315ZM8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm1 9.667a1 1 0 0 1-1 1h-.007a1 1 0 1 1 0-2H8a1 1 0 0 1 1 1ZM9 9H7V3h2v6Z' fill='%23F780AD'/%3E%3C/svg%3E")
}
.info__item:last-child {
  margin-bottom: 0
}
.info__text {
  font-size: 12px;
  line-height: 16px;
  color: #2b1b35;
  opacity: .7;
  padding-bottom: 16px
}
.info__text p {
  margin: 12px 0
}
.info__text p:first-child {
  margin-top: 0
}
.info__text p:last-child {
  margin-bottom: 0
}

.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 145px 0
}
.loader__text {
  margin-top: 24px;
  padding: 0 12px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center
}

.main-form__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 16px
}
.main-form__label {
  font-size: 10px;
  line-height: 12px;
  text-align: right;
  color: #1248b2;
  text-decoration: none;
  cursor: pointer;
  transition: opacity .3s ease
}
.main-form__label:hover {
  opacity: .7
}
.main-form__title {
  font-weight: 600;
  font: 16px/20px var(--font-family-sm);
  margin: 0
}
.main-form__field {
  margin-bottom: 20px
}
.main-form__field:last-child {
  margin-bottom: 0
}
.main-form__caption {
  font: 14px/17px var(--font-family-sm);
  margin-bottom: 20px;
  font-weight: 600
}
.main-form__item {
  margin-bottom: 20px
}
.main-form__item:last-child {
  margin-bottom: 0
}
.main-form__load-more {
  margin-top: 16px;
  font-weight: 600;
  font: 12px/14px var(--font-family-sm);
  letter-spacing: 1.35px;
  text-transform: uppercase;
  color: #164cb5;
  text-align: center;
  cursor: pointer;
  transition: opacity .3s ease
}
.main-form__load-more:hover {
  opacity: .7
}
.result-widget {
  padding: 24px 12px;
  margin-top: 30px;
  border-radius: 8px;
  background: #f5f6f7
}
.result-widget__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px
}
.result-widget__title {
  font: 16px/20px var(--font-family-sm);
  font-weight: 600
}
.result-widget__price {
  display: flex;
  flex-direction: column;
  text-align: right;
  font-weight: 600;
  font: 14px/17px var(--font-family-sm)
}
.result-widget__price-old {
  margin-top: 4px;
  font-size: 10px;
  line-height: 12px;
  text-decoration-line: line-through;
  color: #2b1b35;
  font-weight: 400;
  opacity: .6
}

.result-widget__chars, .result-widget__list {
  margin-bottom: 16px
}

.result-widget__link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin-bottom: 10px;
  font-size: 12px;
  line-height: 16px;
  color: #2b1b35;
  border-radius: 3px;
  background: #fff;
  text-decoration: none;
  opacity: 1;
  transition: opacity;
  cursor: pointer
}
.result-widget__link:hover {
  opacity: .7
}
.result-widget__link:last-child {
  margin-bottom: 0
}

.result-widget__link:after {
  content: "";
  width: 6px;
  height: 8px;
  display: block;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='6' height='8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='.8' clip-path='url(%23a)'%3E%3Cpath d='m1.666 6.666 2.667-2.667-.014-.013-2.653-2.653' stroke='%232B1B35' stroke-width='2' stroke-miterlimit='10' stroke-linecap='square'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' transform='matrix(0 -1 -1 0 6 8)' d='M0 0h8v6H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")
}
.result-widget__info {
  margin-bottom: 16px
}
.result-widget__info:last-child {
  margin-bottom: 0
}
.result-widget .splide:not(.is-active) .splide__slide:not(:first-child) img {
  display: none
}
.result-widget .splide__pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 0 16px;
  padding: 0
}
.result-widget .splide__pagination li {
  margin-right: 6px
}
.result-widget .splide__pagination li:last-child {
  margin-right: 0
}
.result-widget .splide__pagination button {
  display: flex;
  width: 6px;
  height: 6px;
  border: 0;
  padding: 0;
  border-radius: 50%;
  background: #164cb5;
  opacity: .2
}
.result-widget .splide__pagination button.is-active {
  opacity: 1
}
.result-widget .splide__slide {
  display: flex;
  align-items: center;
  justify-content: center
}


.result-widget__body{
    display: flex;
    flex-direction: column;
}

.result-widget__consult-button{
    display: inline-flex;
    margin-left: auto;
    margin-right: auto;
    margin-top: 28px;
    margin-bottom: 10px;
    color: #164CB5;
    font-family: var(--font-family-b);
    text-align: center;
    font-size: 12px;
    line-height: normal;
    letter-spacing: 1.35px;
    text-transform: uppercase;
    border: 0;
    background: 0;
}

.result-widget__consult-button:hover{
    text-decoration: underline;
}

.section {
  padding: 0 !important
}
.section__header {
  margin-bottom: 5px;
  padding: 0 12px
}
.section__title {
  font-weight: 600;
  font: 22px/26px var(--font-family-sm);
  text-align: center
}
.section__caption {
  margin-top: 20px;
  font-size: 14px;
  line-height: 17px;
  text-align: center
}
.section__row {
  padding: 28px 0;
  border-top: 1px solid #e4e7eb
}
.section__row:not(.section__row~.section__row) {
  border-top: 0;
  padding-top: 0
}

.stats-modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  padding: 70px 12px 20px 12px;
  display: none;
  z-index: 99
}
.stats-modal.active {
  display: block
}
.stats-modal__header {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  width: 100%;
  padding: 20px 12px;
  margin: 0 auto;
  max-width: 544px;
  z-index: 995;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center
}

.stats-modal__heading {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px
}
.stats-modal__close {
  position: absolute;
  left: 12px;
  top: 21px;
  transition: opacity .3s ease;
  padding: 0 10px 10px 0;
  cursor: pointer;
  opacity: 1
}
.stats-modal__close :hover {
  opacity: .7
}
.stats-modal__item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 0;
  font-size: 14px;
  line-height: 17px;
  border-bottom: 1px solid #e4e7eb
}
.stats-modal__title {
  max-width: 210px
}
.stats-modal__val {
  text-align: right;
  max-width: 82px;
  word-break: break-all
}

@keyframes splide-loading {
  0% {
    transform: rotate(0)
  }
  to {
    transform: rotate(1turn)
  }
}
.splide__track--draggable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none
}

.splide__track--fade > .splide__list > .splide__slide {
  margin: 0 !important;
  opacity: 0;
  z-index: 0
}

.splide__track--fade > .splide__list > .splide__slide.is-active {
  opacity: 1;
  z-index: 1
}

.splide--rtl {
  direction: rtl
}

.splide__track--ttb > .splide__list {
  display: block
}

.splide__container {
  box-sizing: border-box;
  position: relative
}

.splide__list {
  backface-visibility: hidden;
  display: flex;
  height: unset;
  margin: 0 !important;
  padding: 0 !important
}

.splide.is-initialized:not(.is-active) .splide__list {
  display: block
}

.splide__pagination {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
  pointer-events: none
}

.splide__pagination li {
  display: inline-block;
  line-height: 1;
  list-style-type: none;
  margin: 0;
  pointer-events: auto
}

.splide:not(.is-overflow) .splide__pagination {
  display: none
}

.splide__progress__bar {
  width: 0
}

.splide {
  position: relative;
  visibility: hidden;
  margin-bottom: 12px
}

.splide.is-initialized, .splide.is-rendered {
  visibility: visible
}

.splide__slide {
  backface-visibility: hidden;
  box-sizing: border-box;
  flex-shrink: 0;
  list-style-type: none !important;
  margin: 0;
  position: relative
}

.splide__slide img {
  vertical-align: bottom;
  width: 100%
}

.result-widget .splide__slide:not(:first-child) img {
  max-width: 58%;
}

.splide__spinner {
  animation: splide-loading 1s linear infinite;
  border: 2px solid #999;
  border-left-color: transparent;
  border-radius: 50%;
  bottom: 0;
  contain: strict;
  display: inline-block;
  height: 20px;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 20px
}

.splide__sr {
  clip: rect(0 0 0 0);
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px
}

.splide__toggle.is-active .splide__toggle__play, .splide__toggle__pause {
  display: none
}

.splide__toggle.is-active .splide__toggle__pause {
  display: inline
}

.splide__track {
  overflow: hidden;
  position: relative;
  z-index: 0
}
.analyze_input {
  opacity: .5;
  border: none !important;
  outline: none !important;
  height: 37px;
  position: unset;
  font-size: 12px;
  max-width: 100%;
  border-radius: 4px;
  flex-wrap: wrap;
  display: flex;
  overflow: hidden;
  width: 100%;
  flex: 1 1;
  line-height: 16px
}
.analyze_input.is-active {
  opacity: 0
}
.custom-input.error:hover {
  border-color: #dc3545;
  box-shadow: 0 0 0 .2rem rgba(220, 53, 69, .25)
}
.usual-url {
  transition: opacity .3s ease
}
.usual-url:hover {
  opacity: .7
}
#calc_container {
  background: #ffffff;
}
#calc_container.without_padding {
  padding-top: 0;
}

.form-thx {
  padding: 176px 0 24px;
  text-align: center;
  transition: opacity .2s ease
}
.form-thx .h2, .form-thx h2 {
  color: #2b1b35;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  margin: 0 0 21px;
  text-align: center
}
@media (min-width: 768px) {
  .form-thx .h2, .form-thx h2 {
    font-size: 32px;
    font-weight: 800;
    line-height: 40px;
    margin: 0 0 24px
  }
}
@media (min-width: 1360px) {
  .form-thx .h2, .form-thx h2 {
    font: 40px/48px var(--font-family-sm)
  }
}
.form-thx p {
  color: #2b1b35;
  font: 18px/24px var(--font-family-rg), sans-serif;
  text-align: left;
  margin: 0 auto;
  padding: 14px 0 0 0
}
.form-thx hr {
  background: rgba(43, 27, 53, .1);
  border: none;
  height: 1px;
  margin: 40px auto;
  max-width: 680px;
  padding: 0;
  width: 100%
}
.form-thx-btns {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 16px 0 0;
  margin-top: 32px
}
.form-thx-btns a {
  margin: 0 8px 16px;
  min-width: 220px;
  padding: 0 24px;
  font-family: 14px/17px var(--font-family-sm)
}
.form-thx-btns a.btn-270 {
  min-width: 270px;
  width: 100%
}

.popup-run-new > div {
  max-width: 1600px;
  padding: 0 12px;
  margin: 0 auto;
  position: relative
}

.fancybox-close-small {
  display: none !important
}


.helper {
  display: inline-flex;
  position: relative;
  flex-shrink: 0;
  margin-top: 2px;
  width: 16px;
  height: 20px;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='20' viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.2'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.34315 3.34315C3.84344 1.84285 5.87827 1 8 1C10.1217 1 12.1566 1.84285 13.6569 3.34315C15.1571 4.84344 16 6.87827 16 9C16 11.1217 15.1571 13.1566 13.6569 14.6569C12.1566 16.1571 10.1217 17 8 17C5.87827 17 3.84344 16.1571 2.34315 14.6569C0.842855 13.1566 0 11.1217 0 9C0 6.87827 0.842855 4.84344 2.34315 3.34315ZM8 15C9.5913 15 11.1174 14.3679 12.2426 13.2426C13.3679 12.1174 14 10.5913 14 9C14 7.4087 13.3679 5.88258 12.2426 4.75736C11.1174 3.63214 9.5913 3 8 3C6.4087 3 4.88258 3.63214 3.75736 4.75736C2.63214 5.88258 2 7.4087 2 9C2 10.5913 2.63214 12.1174 3.75736 13.2426C4.88258 14.3679 6.4087 15 8 15ZM7 6.333C7 5.78072 7.44772 5.333 8 5.333H8.007C8.55928 5.333 9.007 5.78072 9.007 6.333C9.007 6.88528 8.55928 7.333 8.007 7.333H8C7.44772 7.333 7 6.88528 7 6.333ZM7 8H9C9 8 9 8.78899 9 9V11.667C9 11.9342 9 12.667 9 12.667H7C7 12.667 7 12.2193 7 11.667V9C7 8.44772 7 8 7 8Z' fill='%232B1B35'/%3E%3C/g%3E%3C/svg%3E%0A");
}

.custom-counter__title.is-flex {
  display: flex;
  align-items: flex-start;
}

.custom-counter.flex-start {
  align-items: flex-start;
}

.custom-counter.flex-start .custom-counter__data {
  margin-top: 2px;
}

.main-form__tab {
  display: block;
}

.main-form__tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 24px;
  margin: 24px 0;
  border-bottom: 1px solid #E4E7EB;
}

.main-form__tabs-item {
  font-family: var(--font-family-sm);
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #1248B2;
  cursor: pointer;
  transition: 0.5s;
}

.main-form__tabs-item.is-active {
  color: #2B1B35;
  transition: 0.5s;
  position: relative;
}

.main-form__tabs-item.is-active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -25px;
  height: 3px;
  width: 100%;
  background: #1248B2;
}

.main-form__text {
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: 24px;
}

@media (max-width: 387px) {
  .custom-input.two-row .custom-input__hidden-input {
    position: absolute;
    width: auto;
    left: 12px;
    top: 15px;
    padding-top: 13px;
    z-index: 1
  }
  .custom-input.two-row .custom-input__inner {
    flex: 0 1 auto;
    z-index: 2
  }
  .custom-input.two-row .custom-input__label {
    padding-right: 12px;
    height: 52px
  }
}
@media (max-width: 365px) {
  .custom-input.two-row .custom-input__hidden-input {
    left: 8vw
  }
}
@media (max-width: 346px) {
  .custom-input.two-row .custom-input__hidden-input {
    left: 12vw
  }
}
@media (max-width: 339px) {
  .custom-input.two-row .custom-input__hidden-input {
    left: 18vw
  }
}

@media (min-width: 1024px) {
  .section__title {
    font-size: 40px;
    line-height: 48px
  }
  .section__caption {
    font-size: 16px;
    line-height: 18px
  }
  .main-form__title {
    font-size: 24px;
    line-height: 30px
  }
  .main-form__header {
    margin-bottom: 24px
  }
  .main-form__caption {
    font-size: 16px;
    line-height: 20px
  }

  .custom-counter__title, .custom-input__label, .custom-radio__label {
    font-size: 15px;
    line-height: 18px
  }

  .custom-input__hidden-input, .custom-input__input {
    font-size: 14px;
    line-height: 16px
  }
  .cont {
    padding-top: 52px;
    max-width: 616px
  }
  .stats-modal__header{
    max-width: 616px
  }
  #calc_container {
    background: #ffffff;
  }
  #calc_container.without_padding {
    padding-top: 0;
  }
  .list-enter-active, .list-leave-active {
    height: 39.6px
  }
  .list-enter-from, .list-leave-to {
    height: 0
  }
  .popup-run-new > div {
    padding: 0 100px
  }
  .form-thx-btns a.btn-270 {
    width: unset
  }
  .form-thx p {
    max-width: 680px
  }
  .feedback__title.result-title {
    margin-bottom: 24px;
    font-size: 30px;
    line-height: 34px
  }
  .custom-input__hidden-input.date_analyze + .custom-input__inner .custom-input__input {
    margin-top: 2px
  }
  .custom-input__hidden-input {
    padding: 12px 0 10px 0
  }
  .feedback__caption {
    font-size: 12px
  }
  .result-widget__title {
    font-size: 20px;
    line-height: 24px
  }
  .result-widget__price {
    font-size: 18px;
    line-height: 20px
  }
  .result-widget__price-old {
    font-size: 13px;
    line-height: 17px
  }
  .chars__item {
    line-height: 20px
  }

  .chars__item, .result-widget__link {
    font-size: 14px
  }
  .stats-modal__item {
    font-size: 15px
  }
  .stats-modal__title {
    max-width: 55%
  }
  .stats-modal__heading {
    font-size: 20px;
    line-height: 24px
  }
  .stats-modal__close {
    top: 25px
  }
  .feedback__policy {
    font-size: 13px
  }
  .info__text {
    font-size: 14px;
    line-height: 17px
  }
  .info__item {
    font-size: 14px;
    line-height: 18px
  }
}
.under_button {
  padding: 16px 0 0 0
}
.feedback__file {
  padding-top: 10px;
}
.feedback__file label {
  font-size: 14px;
  line-height: 17px;
  margin-left: 10px;
  position: relative;
  bottom: 3px;
}

.feedback__file svg {
  position: relative;
  display: inline-block;
}

.feedback__file input[type='file'] {
    width: 85%;
    display: inline-block;
    line-height: 17px;
    margin-left: 10px;
    position: relative;
    bottom: 3px;
    font-size: 14px;
    box-sizing: initial;
    transition: .2s ease;
    -webkit-transition: .2s ease;
    -moz-transition: .2s ease;
    -o-transition: .2s ease;
}

.feedback__file input[type='file']:focus, .input-parent input[type='file']:hover {
    border-color: #0049bc;
}

.feedback__file input[type='file'].error {
    border-color: red !important
}

.feedback_file::-webkit-file-upload-button {
    position: absolute;
    visibility: hidden;
}

.feedback_file::before {
    content: 'Прикрепить анализ воды';
    display: inline-block;
    border-radius: 3px;
    margin-right: 10px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 400;
    font-size: 14px;
    border-right-color: rgb(43 27 53);
    border-right-width: 1px;
    border-right-style: dotted;
    padding: 5px 10px 5px 0px;
}

.feedback__file-format-error, .feedback__file-size-error {
    color: #ee005a !important;
    font-size: 14px;
    margin-left: 26px;
    margin-right: 26px;
    margin-top: 15px;
}
.feedback__file-format-error, .feedback__file-size-error {
    display: inherit;
}
.feedback__file-help {
    font-size: 10px;
    line-height: 12px;
    margin-top: 4px;
    margin-left: 27px;
    color: #727272;
    display: block;
    position: relative;
}
.feedback__file img {
    margin-bottom: 0;
}
.feedback__close_btn {
    position: absolute;
    top: 15px;
    right: 0px;
}
@media (min-width: 390px) {
  .three_chars .chars__item {
    border-left: 1px solid #e4e7eb;
  }
}
.commercial_ch_div {
    margin-top: 10px;
    margin-bottom: 20px;
}
.commercial_ch_div input[type="checkbox"]{
    margin-right: 10px;
    vertical-align: top;
}

.checkbox-error-message-div {
    margin-top: 5px;
}

.checkbox-error-message {
    color: red;
}

</style>
